import React, { useContext } from 'react'
import './style.scss'
import Button from '../../components/Button'
import LogoP from '../../assets/images/banco-pan-logo-cinza/banco-pan-logo-cinza@3x.jpg'

import { AppContext } from "../../store";

const toPlans = () => {
    document.getElementById("home").scrollIntoView()
}

export default function SectionIWant() {
    const { state } = useContext(AppContext)

    return (
        <section className="container-section-i-want">
            <div className="container-icon-text">
                <div className="icon">
                    <img alt="Logo Banco Pan" src={LogoP} />
                </div>
                <div className="container-description">
                    <span>Cliente PAN já começa a usar com isenção em {state.mainBonus} mensalidades. <br /> Aproveite as vantagens de ser PAN e Veloe.</span>
                    <div className="container-btn">
                        <Button onClick={toPlans} text="Eu quero!" />
                    </div>
                </div>
            </div>
        </section>
    )
}